export default "__VITE_ASSET__fb156564__"